import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ChooseGameComponent } from './choose-game/choose-game.component';
import { LeaderBoardListComponent } from './leader-board/leader-board-list/leader-board-list.component';
import { MatchGameComponent } from './match-game/match-game.component';
import { TriviaGameComponent } from './trivia-game/trivia-game.component';


const routes: Routes = [
  {path: '',redirectTo: '/choose', pathMatch: 'full'},
  {path: 'choose', component: ChooseGameComponent},
  {path: 'match-game/:id', component: MatchGameComponent},
  {path: 'trivia-game/:id', component: TriviaGameComponent},
  {path: 'leader-board-list', component: LeaderBoardListComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
